import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http } from '@angular/http';

//import { Globals } from './globals'
import { HorizonCalcComponentService } from './horizoncalcComponent.service';
import { Subscription }   from 'rxjs/Subscription';

@Injectable()
export class HorizonCalc {
    //private _globals:Globals;
    
    constructor(private http: Http, private _srvc: HorizonCalcComponentService) {
        //this._globals = new Globals();
	}

    loadSetup(calcId: string) {
		console.log('HorizonCalc : loadSetup : Start : ' + calcId);
        
        return new Promise((resolve, reject) => {
			resolve(true);
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/horizoncalc/horizoncalc.ts